/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { clipzyGetClipzyGet } from "../../funcs/clipzyGetClipzyGet.js";
import { GetClipzyGetRequest$zodSchema } from "../../models/getclipzygetop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetClipzyGetRequest$zodSchema,
};

export const tool$clipzyGetClipzyGet: ToolDefinition<typeof args> = {
  name: "clipzy--get-clipzy-get",
  description: `步骤2 (方法一): 获取加密数据

**此接口用于“最高安全等级”方法。**

您提供第一步中获得的ID，它会返回存储在服务器上的**加密数据**。您需要在自己的客户端中，使用您自己保管的密钥来解密它。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await clipzyGetClipzyGet(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
